import { ModalLayer, newModalLayer } from "#skyward_modalLayer";
import { createAjaxManager } from "./skyward.base.ajaxManager";
import { MainMenuController } from "./types";
import { Classes, MainMenuCache, createCache, MenuData, MainMenuContext, MainMenu } from "./vue/mainMenu";

let cache: MainMenuCache | null = null;
const skyward = window.skyward;
skyward.mainMenuVueBuilder =
{
    getMainMenuVue: setup,
    getCache: () => cache === null ? (cache = createCache($, skyward.global, createAjaxManager())) : cache,
    getClasses: () => Classes
};

/* TODO: [PR 4380821] Enable once Mobile Main Menu is ready
skyward.window.registerLoadDOMCallback(init);
function init(this: JQuery)
{
    const context = this;
    const menuButton = $("." + Classes.jsDesktopMenuVisibilityToggle)[0];

    context.find("." + Classes.menuSource).each(function ()
    {
        setup(this, menuButton);
    });
}
*/

function setup(menuDataElement: HTMLElement, menuButtonElement: HTMLElement): MainMenuController
{
    let layer: ModalLayer;
    const menuButton = $(menuButtonElement);
    const menuData: MenuData = $(menuDataElement).data().menu;

    /* TODO: [PR: 4380821] Just instantiate the cache here once Mobile Main Menu is ready
    const ajaxManager: IAjaxManager = createAjaxManager();
    const cache: ICache = createCache($, skyward.global, ajaxManager);
    */

    const cache: MainMenuCache = skyward.mainMenuVueBuilder.getCache();
    cache.initializeOnDomLoad(menuDataElement, menuData);

    const context: MainMenuContext =
    {
        container: document.createElement("div"),
        isMobile: skyward.global.mobileAccess,
        menuData: cache,
        window: skyward.window,
        newWindowOpened: closeMenu
    };
    const vm = MainMenu.buildVue(context);

    let isOpen = false;
    menuButton.on("click", toggleMenu);

    const mainMenu: MainMenuController =
    {
        isMenuOpen: () => isOpen,
        toggleMenu: toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu
    };
    return mainMenu;

    function toggleMenu()
    {
        if (isOpen) { closeMenu(); } else { openMenu(); }
    }

    function openMenu()
    {
        vm.setTopPosition(getTopPosition(menuButton));
        vm.toggleOpen(true);

        layer = newModalLayer(vm.$el as HTMLElement, closeMenu);

        isOpen = true;
        menuButton.attr("aria-expanded", isOpen.toString());
    }

    function closeMenu()
    {
        vm.toggleOpen(false);
        isOpen = false;

        // Move the menu out of modal layer so it isn't removed along with it while animating
        document.body.append(vm.$el);

        layer.close();

        menuButton.attr("aria-expanded", isOpen.toString());
    }
}

function getTopPosition(button: JQuery<HTMLElement>): number
{
    const offsetTop = button[0]?.getBoundingClientRect().bottom ?? 0;
    const navBarBottomPadding = 2;

    return offsetTop + navBarBottomPadding;
}